import { z } from 'zod';

export type ChangelogVersion = z.infer<typeof ChangelogVersion>;
export type ChangelogResponse = z.infer<typeof ChangelogResponse>;

export const ChangelogLanguage = z.object({
  summary: z.string(),
  href: z.url(),
});

export const ChangelogVersion = z.object({
  id: z.string(),
  date: z.string(),
  summary: z.string().nullish(),
  href: z.url().nullish(),
  languages: z.record(z.string(), ChangelogLanguage).optional(),
});

export const ChangelogResponse = z.object({
  changelog: z.array(ChangelogVersion),
});
